<template lang="">
  <div>
    <PositionGuid :posGuids="posGuids"></PositionGuid>
    <div class="gWidth bg-white padding" id="map" v-cloak>
      <section class="mapbox bg-white">
        <div class="head_topp">
          投诉举报
        </div>
        <ul class="flex-container">
            <li class="left-item">
                <div style="display:block;
	color: #c04040;
	font-size: 22px;
	width:280px !important;
	text-align:left;
	line-height:35px;
	font-weight:500;">安全生产举报电话</div>
                <div style="display:block;
	color: #c04040;
	font-size: 22px;
	width:280px !important;
	text-align:left;
	line-height:35px;
	font-weight:500;">高新区：</div>
                <div style="line-height: 38px; 	font-size: 18px;">0312-3108801</div>
                <div style="display:block;
	color: #c04040;
	font-size: 22px;
	width:280px !important;
	text-align:left;
	line-height:35px;
	font-weight:500;">保定市：</div>
                <div style="line-height: 38px; 	font-size: 18px;">0312-3088800</div>
                <div style="display:block;
	color: #c04040;
	font-size: 22px;
	width:280px !important;
	text-align:left;
	line-height:35px;
	font-weight:500;">河北省：</div>
                <div style="line-height: 38px; 	font-size: 18px;">0311-12350</div>

                <div style="display:block;
	color: #c04040;
	font-size: 22px;
	text-align:left;
	line-height:35px;
	font-weight:500;">安全生产事故、隐患、违法行为举报邮箱：</div>
                <div style="line-height: 38px; 	font-size: 18px;">gxq3195760@163.com</div>

              <div style="display:block;
	color: #c04040;
	font-size: 22px;
	width:280px !important;
	text-align:left;
	line-height:35px;
	font-weight:500;">安全生产举报系统：</div>
              <div style="line-height: 38px;">https://dctjfx.mem.gov.cn/aqscjb#/</div>
            </li>
            <li class="right-item">
            <div><img src="https://www.bdgxq.gov.cn/img/1682563105519008984.jpg" Width="200px"></div>
            <div>安全生产举报微信小程序</div>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>
<script>
import PositionGuid from "../../components/PositionGuid/PositionGuid";
export default {
  name: "Tousujubao",
  components: {
    PositionGuid,
  },
  data() {
    return {
      posGuids: [
        {
          title: "投诉举报",
          link: "",
        },
      ],
    };
  },
};
</script>
<style src="../../../vab/styles/map/map_big.css" scoped></style>
<style src="../../../vab/styles/map/map_small.css" scoped></style>
<style scoped>
.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.left-item {
  flex: 1;
  margin-right: 20px;
  margin-left: 10%;
  margin-bottom: 30px;
}

.right-item {
  flex: 0 0 auto;
  text-align: center;
  margin-right: 10%;
}
</style>
